
module.exports = function()
{
    this.franchisor = null    
    this.franchisee = null    
    this.property = null    
    this.priceBands = [];
    this.suppliers = [];
}